import styles from './SearchDropdown.module.scss';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectTimeslicerEndMonth,
    selectTimeslicerStartMonth,
    selectZoneValue
} from 'selectors/selectors';
import { fetchFilteredDropdownValues } from 'slices/FiltersSlice';
import { FilterType } from 'types/types';
import { generateRequestParamsForFilterApi } from 'utils/api';
import { useLocation } from 'react-router-dom';

const SearchDropdown = (props) => {
    const { pathname } = useLocation();
    const { label, data, navigateTo } = { ...props };
    const [value, setValue] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const inputRef = useRef(null);
    const dispatch = useDispatch();

    const tsStart = useSelector(selectTimeslicerStartMonth);
    const tsEnd = useSelector(selectTimeslicerEndMonth);
    const zoneValue = useSelector(selectZoneValue);
    const generateFilteredValues = () => {
        if (!data) return [];
        if (value === '') return data;
        return data.filter((item) => item.label.includes(value));
    };

    const generateUpdateFiltersParams = (rm) => {
        const requestParamsObj = generateRequestParamsForFilterApi(
            tsStart ? tsStart.epoch : null,
            tsEnd ? tsEnd.epoch : null,
            zoneValue,
            null,
            null,
            rm.value
        );
        const enrichedParamsObj = {
            requestParams: {
                ...requestParamsObj.requestParams,
                selectedFilterType: FilterType.RM,
                label: rm.label,
                value: rm.value
            }
        };
        dispatch(fetchFilteredDropdownValues(enrichedParamsObj));
    };
    return (
        <div className={styles.wrapper}>
            <input
                type={'search'}
                className={`${value ? styles.hideIconInput : styles.input}`}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                    if (!_.isEmpty(e.target.value)) setShowOptions(true);
                }}
                onBlur={() => setShowOptions(false)}
                ref={inputRef}
            />
            <span
                className={`${
                    value ? styles.hidePlaceholder : styles.placeholder
                }`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => inputRef.current.focus()}
            >
                {label}
            </span>
            {showOptions && value && (
                <div
                    className={
                        generateFilteredValues().length === 0
                            ? styles.dropdownContainerNoResults
                            : styles.dropdownContainer
                    }
                >
                    {generateFilteredValues().length === 0 ? (
                        <div className={styles.noResult}>No Results</div>
                    ) : (
                        generateFilteredValues().map((item, idx) => (
                            <p
                                key={`${item}-${item.label}-${idx}`}
                                className={styles.dropdownItem}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    generateUpdateFiltersParams(item);
                                    navigateTo(pathname, '/rm');
                                    setShowOptions(false);
                                    setValue('');
                                }}
                            >
                                {item.label}
                            </p>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

SearchDropdown.propTypes = {
    label: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.number,
            label: PropTypes.string
        })
    ),
    navigateTo: PropTypes.func
};

export default SearchDropdown;
